import * as React from 'react';
import { ExperienceTransferFormProps } from '../types';
import { ExperienceTransferContainer } from './experience-transfer-container';
import { ExperienceTransferDetailsContainer } from './experience-transfer-details';

const ExperienceTransferFormRendererContainer: React.FC<ExperienceTransferFormProps> = ({
  locale, translation, options, shouldPrompt, actionType, formState,
  saveExperienceTransfer, deleteExperienceTransfer, updateItem, updateValidation,
  displayError, resetValidation, clearValidation, loadOptions
}) => {

  const { experienceTransferItem, validation } = formState;

  const panelProps = {
    actionType,
    experienceTransferItem,
    options,
    locale,
    validation,
    translation,
    resetValidation,
    clearValidation,
    updateItem,
    updateValidation,
    displayError,
    loadOptions
  };

  return <ExperienceTransferContainer
    actionType={actionType}
    formState={formState}
    shouldPrompt={shouldPrompt}
    saveExperienceTransfer={saveExperienceTransfer}
    deleteExperienceTransfer={deleteExperienceTransfer}
    updateValidation={updateValidation}
    displayError={displayError}
    validation={validation}
    translation={translation}>
    <ExperienceTransferDetailsContainer {...panelProps} />
  </ExperienceTransferContainer>;
};

export const ExperienceTransferFormRenderer = ExperienceTransferFormRendererContainer;

